export const paginationComponentEditDisplay = [
    {
        key: 'placeholder',
        ignore: true,
    },
    {
        key: 'labelPosition',
        ignore: true,
    },
    {
        key: 'tooltip',
        ignore: true,
    },
    {
        key: 'tabindex',
        ignore: true,
    },
    {
        key: 'autofocus',
        ignore: true,
    },
    {
        key: 'hideLabel',
        ignore: true,
    },
    {
        key: 'disabled',
        ignore: true,
    },
    {
        key: 'tableView',
        ignore: true,
    },
    {
        key: 'autofocus',
        ignore: true,
    },
    {
        key: 'customClass',
        ignore: true,
    },
    {
        key: 'hidden',
        ignore: true,
    },
    {
        key: 'modalEdit',
        ignore: true,
    },
    {
        key: 'description',
        ignore: true,
    },
    {
        key: 'label',
    },
    {
        type: 'textfield',
        input: false,
        label: 'Items per page',
        key: 'itemsPerPage',
        defaultValue: 10,
        weight: 0,
        validate: {
            required: true,
        },
    },
    {
        type: 'checkbox',
        input: false,
        label: 'Show next and previous buttons',
        key: 'showNextPrevBtns',
        defaultValue: true,
        weight: 2,
    },
    {
        type: 'checkbox',
        input: false,
        label: 'Show items per page dropdown',
        key: 'showItemsPerPageDropdown',
        defaultValue: true,
        weight: 3,
    }
];